import api from "@/service/api";

const state = () => ({
    currentBrand: null,
    callCount: null,
    creatorVideoUpvotedCount: null,
    creatorRequestCount: null,
    purchasedGalleryCount: null,
    viewedProfileCount: null,
    unseenCreatorRequestCount: null,
    creatorSubscriptionCount: null,
})

const mutations = {
    setCurrentBrand(state, value) {
        state.currentBrand = value;
    },
    setCallCount(state, value) {
        state.callCount = value;
    },
    setCreatorVideoUpvotedCount(state, value) {
        state.creatorVideoUpvotedCount = value;
    },
    setCreatorRequestCount(state, value) {
        state.creatorRequestCount = value;
    },
    setPurchasedGalleryCount(state, value) {
        state.purchasedGalleryCount = value;
    },
    setUnseenCreatorRequestCount(state, value) {
        state.unseenCreatorRequestCount = value;
    },
    setViewedProfileCount(state, value) {
        state.viewedProfileCount = value;
    },
    setCreatorSubscriptionCount(state, value) {
        state.creatorSubscriptionCount = value;
    },
}

const actions = {
    refresh({ commit }) {
        api.post('/account/dashboard').then((response) => {
            commit('setCurrentBrand', response?.data?.currentBrand)
            commit('setCallCount', response?.data?.callCount)
            commit('setCreatorVideoUpvotedCount', response?.data?.creatorVideoUpvotedCount)
            commit('setCreatorRequestCount', response?.data?.creatorRequestCount)
            commit('setPurchasedGalleryCount', response?.data?.purchasedGalleryCount)
            commit('setUnseenCreatorRequestCount', response?.data?.unseenCreatorRequestCount)
            commit('setViewedProfileCount', response?.data?.viewedProfileCount)
            commit('setCreatorSubscriptionCount', response?.data?.creatorSubscriptionCount)
        });
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}